export default __webpack_public_path__ + "static/media/check.69aee4fa.jpg";